import PT from "prop-types";
import React, { useRef, useState } from "react";
// Using our custom SearchBox for tracking instead of Quintype's
import get from "lodash/get";
import { useSelector } from "react-redux";
import { SearchBox } from "../../molecules/SearchBox";
import { getTemplateName } from "../../utils";

import { STATIC_KEYWORDS } from "../../../constants";
import { getCategoryAndSubCategory } from "../../../ga-utils";
import { MenuItem } from "../../layouts/menu-item";
import AppLogo from "../AppLogo";
import SearchIcon from "../Search";
import AuthButton from "../AuthButton";
import { SvgIconHandler } from "../SvgIconHandler";

import "./hamburger-menu.m.css";
import Button from "../Button";

const DropdownMenu = ({ onMenuToggle, hamburgerMenu, isMegaMenuOpen, disableSearch = false, ctaButton }) => {
  const { SIGN_IN, SUBSCRIBE, ANNUAL_SUBSCRIPTION, GO_AD_FREE } = STATIC_KEYWORDS;
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef({});
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);
  const sketchesHost = useSelector((state) => get(state, ["qt", "config", "sketches-host"]));
  const config = get(qtState, ["config"], "");
  const fromLocation = get(qtState, ["data", "story"], {});
  const enableSubscription = useSelector((state) =>
      get(state, ["qt", "config", "publisher-attributes", "enable_subscription"], false)
    );
  const isSubscriptionPage = pageType === "subscription-page";
  const isAdfree = useSelector((state) => get(state, ["qt", "config", "subscriber"], false));

  const findParentCategory = (item) => {
    if (!item["parent-id"]) {
      return item.title;
    }

    const parentItem = hamburgerMenu?.find((menuItem) => menuItem.id === item["parent-id"]);
    return parentItem ? parentItem.title : "hamburger-menu";
  };

  const trackHamburgerMenuClick = (e, item, isChild = false) => {
    e.preventDefault();
    e.stopPropagation();

    const url = item.completeUrl || "/";
    const fullUrl = url.startsWith("/") && sketchesHost ? `${sketchesHost}${url}` : url;
    const templateName =
      pageType === "story-page" ? getTemplateName(fromLocation?.["story-template"]) : getTemplateName(pageType);
    const parentCategory = isChild ? findParentCategory(item) : item.title;
    const categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, fromLocation);

    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_hamburger_click",
        link_url: fullUrl,
        link_text: item.title.toLowerCase(),
        link_category: parentCategory.toLowerCase(),
        category: categoryInfo.category,
        sub_category: categoryInfo.subCategory,
        content_id: categoryInfo.contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: function () {
          if (item.completeUrl) {
            window.location.href = item.completeUrl;
          }
          if (onMenuToggle) {
            onMenuToggle();
          }
        },
      });
    }
  };

  const toggleDropdown = (itemTitle) => {
    if (activeDropdown === itemTitle) {
      dropdownRef.current[itemTitle].style.maxHeight = "0px";
      setTimeout(() => setActiveDropdown(null), 300);
    } else {
      if (activeDropdown) {
        dropdownRef.current[activeDropdown].style.maxHeight = "0px";
      }
      const dropdownElement = dropdownRef.current[itemTitle];
      if (dropdownElement) {
        dropdownElement.style.maxHeight = `${dropdownElement.scrollHeight}px`;
      }
      setActiveDropdown(itemTitle);
    }
  };

  const itemsWithChildren = hamburgerMenu?.filter((item) => item.children?.length > 0) || [];
  const itemsWithoutChildren = hamburgerMenu?.filter((item) => item.children?.length === 0) || [];
  function DrawForm({ children }) {
    return [
      <label htmlFor="searchForm" key="1" style={{ width: "100%" }}>
        {children}
      </label>,
    ];
  }
  return (
    <div styleName="dropdown-content-wrapper" style={{ left: `${isMegaMenuOpen ? "0px" : "-100vw"}` }}>
      <div styleName="dropdown-content">
        <button styleName="close-hamburger" onClick={onMenuToggle}>
          {/* <SvgIconHandler type="close" width="18" height="18" viewBox="0 0 18 18" /> */}
        </button>
        <div styleName="logo">
          <AppLogo customStyle="app-logo-header" />
          {ctaButton && ctaButton}
          {/* {!ctaButton && pageType !== "custom-event-page" && (
            <AuthButton label={SIGN_IN} path="/user-login" onMenuToggle={onMenuToggle} />
          )} */}
          {enableSubscription && !isSubscriptionPage && !isAdfree && pageType !== "custom-event-page" ? (
            <div styleName="adfree-hamburger">
              <Button socialButton customStyleName="bg-brand-primary" isHamburgerbtn href="/subscription">
                {GO_AD_FREE}
              </Button>
            </div>
          ) : !ctaButton && pageType !== "custom-event-page" && (
            <AuthButton label={SIGN_IN} path="/user-login" onMenuToggle={onMenuToggle} />
          )}
        </div>
        {!disableSearch && (
          <div styleName="search-box">
            <span styleName="search-icon">
              {/* <SvgIconHandler type="search" width="18" height="18" viewBox="0 0 18 18" /> */}
            </span>
            <SearchBox
              styleName="search-input"
              template={DrawForm}
              inputId="searchForm"
              inputClassName=""
              placeholder="Search"
              onSubmitHandler={onMenuToggle}
              searchType="hamburger"
              pageType={pageType}
              config={config}
              fromLocation={fromLocation}
            />
          </div>
        )}

        <ul styleName="menu-items-wrapper">
          {hamburgerMenu?.map((item) => {
            const hasChildren = item.children?.length > 0;
            return (
              <React.Fragment key={item.title}>
                {hasChildren ? (
                  <>
                    <li styleName="dropdown" onClick={() => toggleDropdown(item.title)}>
                      <div onClick={(e) => trackHamburgerMenuClick(e, item)} style={{ display: "contents" }}>
                        <MenuItem menuStyle="menu-link" item={item} toggleHandler={onMenuToggle} />
                      </div>
                      <div styleName={`arrow ${activeDropdown === item.title ? "active" : ""}`}>
                        {/* <SvgIconHandler type="arrow" width="16" height="16" viewBox="0 0 16 16" /> */}
                      </div>
                    </li>
                    <li
                      ref={(el) => (dropdownRef.current[item.title] = el)}
                      styleName={`child-dropdown ${activeDropdown === item.title ? "active" : ""}`}
                    >
                      {item.children.map((child, index) => (
                        <>
                          <div styleName="child-menu" key={child.title}>
                            <div
                              onClick={(e) => trackHamburgerMenuClick(e, child, true)}
                              style={{ display: "contents" }}
                            >
                              <MenuItem menuStyle="child-menu-link" item={child} toggleHandler={onMenuToggle} />
                            </div>
                            {index !== item.children.length - 1 && <div styleName="menu-item-separator"></div>}
                          </div>
                        </>
                      ))}
                    </li>
                  </>
                ) : (
                  <div styleName="child-menu bold">
                    <div onClick={(e) => trackHamburgerMenuClick(e, item)} style={{ display: "contents" }}>
                      <MenuItem menuStyle="child-menu-link bold" item={item} toggleHandler={onMenuToggle} />
                    </div>
                  </div>
                )}
                <div styleName="menu-item-separator"></div>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const HamburgerMenu = ({ onMenuToggle, isMegaMenuOpen, hamburgerMenu, disableSearch = false, ctaButton }) => {
  return (
    <>
      <button aria-label="Hamburger Menu" className="hamburger-menu" onClick={onMenuToggle} styleName={`hamburger`}>
        {/* <SvgIconHandler type="hamburger" width="24" height="24" viewBox="0 0 24 24" /> */}
      </button>
      <DropdownMenu
        isMegaMenuOpen={isMegaMenuOpen}
        onMenuToggle={onMenuToggle}
        hamburgerMenu={hamburgerMenu}
        disableSearch={disableSearch}
        ctaButton={ctaButton}
      />
    </>
  );
};

HamburgerMenu.propTypes = {
  onMenuToggle: PT.func,
  isMegaMenuOpen: PT.bool,
};

export default HamburgerMenu;
